// extracted by mini-css-extract-plugin
module.exports = {"container":"social-sign-in_container__xpJ4l","buttons":"social-sign-in_buttons__fHRHO","button":"social-sign-in_button__SpzkG","twitter":"social-sign-in_twitter___HPck"};